import { AuthApiError, apiBaseUrl } from '../account/authApi';

export type MessageKind = 'contact' | 'feature' | 'bug';

export interface SubmitMessageInput {
  kind: MessageKind;
  subject: string;
  body: string;
  sender_name?: string;
  sender_email?: string;
}

export async function submitMessage(
  input: SubmitMessageInput,
): Promise<{ id: string; status: 'received' }> {
  const response = await fetch(`${apiBaseUrl()}/messages`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(input),
  });
  let body: unknown = null;
  try {
    body = await response.json();
  } catch {
    /* empty / non-JSON */
  }
  if (!response.ok) {
    const detail =
      body && typeof body === 'object' && 'detail' in body && typeof body.detail === 'string'
        ? body.detail
        : null;
    throw new AuthApiError(
      response.status,
      detail,
      `Failed to submit message (${response.status}).`,
    );
  }
  return body as { id: string; status: 'received' };
}
